import { SetStateAction, useEffect, useState } from "react";
import { inputTimeBack } from "../data/docCodes";
import { stdObject } from "../data/types/stdObject";
import WriteInput from "./componentModal/WriteInput";
import { colors } from "../data/colors";
import QuickPersonSearch from "./DocumentModal/components/QuickPersonSearch";
import { checkPriceRange } from "../screens/MainFrame/functions/checkPriceRange";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useMainContext } from "../context/MainContext";

export default function QuickSearchComp({
  code,
  type,
  searchType,
  refInput,
  inputData,
  setInputData,
  updateFunction,
  newFunction,
  casualFunction,
  cleanFunction,
}: stdObject) {
  const { t } = useTranslation();
  const { logoutAction, setMsg2, setModalData2, closeMsg } = useMainContext();
  const pricesRates: Array<stdObject> = useSelector(
    (state: RootState) => state.data.tar,
  );
  const condPricesRates: stdObject[] = useSelector(
    (state: RootState) => state.data.ta0,
  );
  const [resList, setResList] = useState<stdObject[]>([]);
  const [selectPos, setSelectPos] = useState<number>(0);
  useEffect(() => {
    if (inputData.open) {
      refInput.current?.focus();
    }
  }, [inputData.open]);

  return (
    <div
      style={{
        position: "absolute",
        top: 3,
        left: 3,
        zIndex: 20,
      }}
    >
      <WriteInput
        data={{
          refId: refInput,
          value: inputData.search,
          onBlur: () => {
            setTimeout(
              () =>
                setInputData({
                  ...inputData,
                  open: false,
                  code: "",
                  search: "",
                }),
              inputTimeBack,
            );
          },
          onChange: (v: { target: { value: SetStateAction<string> } }) => {
            setInputData({ ...inputData, search: v.target.value });
          },
          onKeyDown: (e: stdObject) => {
            switch (e.key) {
              case "Enter":
                if (resList.length > 0) {
                  setResList([]);
                  setInputData({
                    ...inputData,
                    open: false,
                    code: "",
                    search: "",
                  });
                  checkPriceRange(type, inputData.code, resList[selectPos], {
                    t,
                    updateFunction,
                    condPricesRates,
                    pricesRates,
                    setMsg2,
                    setModalData2,
                    logoutAction,
                    closeMsg,
                  });
                }
                break;
              case "ArrowUp":
                if (resList.length > 1) {
                  if (selectPos > 0) {
                    setSelectPos(selectPos - 1);
                  } else {
                    setSelectPos(resList.length - 1);
                  }
                }
                break;
              case "ArrowDown":
                if (resList.length > 1) {
                  if (selectPos < resList.length - 1) {
                    setSelectPos(selectPos + 1);
                  } else {
                    setSelectPos(0);
                  }
                }
                break;
              case "Escape":
                setInputData({
                  ...inputData,
                  open: false,
                  code: "",
                  search: "",
                });
                break;
            }
          },
          style: {
            position: "absolute",
            border: "solid 1px black",
            padding: 3,
            backgroundColor: colors.white,
            width: 100,
          },
        }}
      />
      <QuickPersonSearch
        code={code}
        type={searchType}
        resList={resList}
        setInputData={setInputData}
        setResList={setResList}
        selectPos={selectPos}
        setSelectPos={setSelectPos}
        target={inputData.code}
        value={inputData.search.trim()}
        updateFunction={updateFunction}
        newFunction={newFunction}
        casualFunction={casualFunction}
        cleanFunction={cleanFunction}
      />
    </div>
  );
}
